var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCountriesNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_80_26",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#C12327"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_80_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 29.3332C14.1556 29.3332 12.4223 28.9832 10.8001 28.2832C9.17786 27.5832 7.76675 26.6332 6.56675 25.4332C5.36675 24.2332 4.41675 22.8221 3.71675 21.1998C3.01675 19.5776 2.66675 17.8443 2.66675 15.9998C2.66675 14.1554 3.01675 12.4221 3.71675 10.7998C4.41675 9.17761 5.36675 7.7665 6.56675 6.5665C7.76675 5.3665 9.17786 4.4165 10.8001 3.7165C12.4223 3.0165 14.1556 2.6665 16.0001 2.6665C17.8445 2.6665 19.5779 3.0165 21.2001 3.7165C22.8223 4.4165 24.2334 5.3665 25.4334 6.5665C26.6334 7.7665 27.5834 9.17761 28.2834 10.7998C28.9834 12.4221 29.3334 14.1554 29.3334 15.9998C29.3334 17.8443 28.9834 19.5776 28.2834 21.1998C27.5834 22.8221 26.6334 24.2332 25.4334 25.4332C24.2334 26.6332 22.8223 27.5832 21.2001 28.2832C19.5779 28.9832 17.8445 29.3332 16.0001 29.3332ZM16.0001 26.6665C18.9779 26.6665 21.5001 25.6332 23.5667 23.5665C25.6334 21.4998 26.6667 18.9776 26.6667 15.9998C26.6667 15.8443 26.6612 15.6832 26.6501 15.5165C26.639 15.3498 26.6334 15.2109 26.6334 15.0998C26.5223 15.7443 26.2223 16.2776 25.7334 16.6998C25.2445 17.1221 24.6667 17.3332 24.0001 17.3332H21.3334C20.6001 17.3332 19.9723 17.0721 19.4501 16.5498C18.9279 16.0276 18.6667 15.3998 18.6667 14.6665V13.3332H13.3334V10.6665C13.3334 9.93317 13.5945 9.30539 14.1167 8.78317C14.639 8.26095 15.2667 7.99984 16.0001 7.99984H17.3334C17.3334 7.48873 17.4723 7.03873 17.7501 6.64984C18.0279 6.26095 18.3667 5.94428 18.7667 5.69984C18.3223 5.58873 17.8723 5.49984 17.4167 5.43317C16.9612 5.3665 16.489 5.33317 16.0001 5.33317C13.0223 5.33317 10.5001 6.3665 8.43341 8.43317C6.36675 10.4998 5.33341 13.0221 5.33341 15.9998H12.0001C13.4667 15.9998 14.7223 16.5221 15.7667 17.5665C16.8112 18.6109 17.3334 19.8665 17.3334 21.3332V22.6665H13.3334V26.3332C13.7779 26.4443 14.2167 26.5276 14.6501 26.5832C15.0834 26.6387 15.5334 26.6665 16.0001 26.6665Z",
    fill: "#C12327"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountriesNumber);
export default __webpack_public_path__ + "static/media/CountriesNumber.4db72256db7743fd424116b20d8d79ae.svg";
export { ForwardRef as ReactComponent };